var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2Point(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ECF0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.1818H24.75H24ZM8 14.1818H7.25H8ZM16 6V6.75V6ZM23.25 14.1818C23.25 16.132 22.4145 18.0394 21.241 19.7472C20.0716 21.4492 18.6078 22.8927 17.4503 23.8994L18.4347 25.0312C19.6451 23.9785 21.21 22.4411 22.4773 20.5967C23.7407 18.758 24.75 16.5533 24.75 14.1818H23.25ZM14.5497 23.8994C13.3922 22.8927 11.9284 21.4492 10.759 19.7472C9.58549 18.0394 8.75 16.132 8.75 14.1818H7.25C7.25 16.5533 8.25934 18.758 9.52267 20.5967C10.79 22.4411 12.3549 23.9785 13.5653 25.0312L14.5497 23.8994ZM8.75 14.1818C8.75 12.2054 9.51784 10.3132 10.8794 8.92074L9.80689 7.87206C8.16787 9.54833 7.25 11.8183 7.25 14.1818H8.75ZM10.8794 8.92074C12.2404 7.5288 14.0827 6.75 16 6.75V5.25C13.6738 5.25 11.4465 6.19522 9.80689 7.87206L10.8794 8.92074ZM16 6.75C17.9173 6.75 19.7596 7.5288 21.1206 8.92074L22.1931 7.87206C20.5535 6.19522 18.3262 5.25 16 5.25V6.75ZM21.1206 8.92074C22.4822 10.3132 23.25 12.2054 23.25 14.1818H24.75C24.75 11.8183 23.8321 9.54833 22.1931 7.87206L21.1206 8.92074ZM17.4503 23.8994C16.604 24.6355 15.396 24.6355 14.5497 23.8994L13.5653 25.0312C14.9761 26.2582 17.0239 26.2582 18.4347 25.0312L17.4503 23.8994Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17C17.6569 17 19 15.6569 19 14C19 12.3431 17.6569 11 16 11C14.3431 11 13 12.3431 13 14C13 15.6569 14.3431 17 16 17Z",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Point);
export default __webpack_public_path__ + "static/media/step2-point.7b1325a1836b0661daa0319e9faddef3.svg";
export { ForwardRef as ReactComponent };